type ChangeType = "positive" | "negative" | "neutral";

export const changeColors = {
  positive: "bg-[#D9F8CD] text-[#008500]",
  negative: "bg-[#F7D0CC] text-[#D6313B]",
  neutral: "bg-grey-100 text-gray-800",
};

export const dynamicChange = (change_in_percent: number): ChangeType => {
  if (change_in_percent < 0) {
    return "negative";
  } else if (change_in_percent > 0) {
    return "positive";
  } else {
    return "neutral";
  }
};

export const getSign = (change_in_percent: number): string => {
  if (change_in_percent > 0) {
    return "+";
  }
  return "";
};
